<template>
  <div>
    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>

    <Card class="one-card">
      <h2 slot="title">邮箱账号</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.accounts_email">
          <Divider v-if="index > 0" :key="index + 'divider'" />
          <Row :gutter="16" :key="index">
            <i-col span="6">
              <FormItem label="账号">
                <i-input v-model="item.account"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="密码">
                <i-input v-model="item.password"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one('accounts_email')"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last('accounts_email')"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">申请系统账号</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.accounts_system">
          <Divider v-if="index > 0" :key="index + 'divider'" />
          <Row :gutter="16" :key="index">
            <i-col span="6">
              <FormItem label="账号类型">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="链接">
                <i-input v-model="item.link"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="账号">
                <i-input v-model="item.account"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="密码">
                <i-input v-model="item.password"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one('accounts_system')"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last('accounts_system')"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">语言考试账号</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.accounts_language">
          <Divider v-if="index > 0" :key="index + 'divider'" />
          <Row :gutter="16" :key="index">
            <i-col span="6">
              <FormItem label="账号类型">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="链接">
                <i-input v-model="item.link"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="账号">
                <i-input v-model="item.account"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="密码">
                <i-input v-model="item.password"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one('accounts_language')"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last('accounts_language')"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">标化账号</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.accounts_standardization">
          <Divider v-if="index > 0" :key="index + 'divider'" />
          <Row :gutter="16" :key="index">
            <i-col span="6">
              <FormItem label="账号类型">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="链接">
                <i-input v-model="item.link"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="账号">
                <i-input v-model="item.account"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="密码">
                <i-input v-model="item.password"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one('accounts_standardization')"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last('accounts_standardization')"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">其他</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.other">
          <Divider v-if="index > 0" :key="index + 'divider'" />
          <Row :gutter="16" :key="index">
            <i-col span="6">
              <FormItem label="账号类型">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="链接">
                <i-input v-model="item.link"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="账号">
                <i-input v-model="item.account"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="密码">
                <i-input v-model="item.password"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one('other')">添加一条</Button>
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last('other')"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>
    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    async getData() {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/student/getAccountInfoById",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.data = res;
    },

    add_one(key) {
      if (!this.data[key]) {
        this.$set(this.data, key, [{}]);
      } else {
        this.data[key].push({});
      }
    },

    delelt_last(key) {
      this.data[key].pop();
    },

    async save() {
      await this.api({
        url: "/student/saveAccountInfo",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          student_id: this.$store.getters.selectedStudent._id,
          accounts_email: JSON.stringify(this.data.accounts_email),
          accounts_system: JSON.stringify(this.data.accounts_system),
          accounts_language: JSON.stringify(this.data.accounts_language),
          accounts_standardization: JSON.stringify(
            this.data.accounts_standardization
          ),
          other: JSON.stringify(this.data.other),
        },
      });

      this.$Message.success("更新成功");
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bolder;
}
.one-card {
  margin-bottom: 20px;
}

.ivu-divider {
  margin: 0 auto 10px;
}
</style>